import React from 'react'
import { Outlet } from 'react-router-dom'
import HeaderImigo from '../../Components/Header/HeaderImigo'
import FooterImigo from '../../Components/Footers/FooterImigo'

const ImigoLayout = () => {
  return (
    <>
      <HeaderImigo />
      <div className="main-content">
        <Outlet />
      </div>
      <FooterImigo />
    </>
  )
}

export default ImigoLayout 